<div class="app-loading">
  <div class="app-loading-wrapper" title="{{ hover | translate}}">
    <svg-icon icon="refresh" class="icon-loading"></svg-icon>
    <h2 class="app-empty-title" *ngIf="heading">{{ heading | translate}}</h2>
    <p class="app-empty-desc" *ngIf="description">{{ description | translate}}</p>
  </div>
</div>
